import { mailEventEmitter, TRIGGER_MAIL_LIST_SCROLL_TO_TOP } from 'mini-mail-event-emitters';
import { useEffect } from 'react';

export const useScrollToTop = (callback: () => void) => {
    useEffect(() => {
        mailEventEmitter.on(TRIGGER_MAIL_LIST_SCROLL_TO_TOP, callback);

        return () => {
            mailEventEmitter.off(TRIGGER_MAIL_LIST_SCROLL_TO_TOP, callback);
        };
        /* eslint-disable-next-line react-hooks/exhaustive-deps --
         * See aka.ms/mini-lint-errors
         *	> React Hook useEffect has a missing dependency: 'callback'. Either include it or remove the dependency array. */
    }, []);
};
